(function () {
  var config = window.currencyDisplay;
  if (!config || config.mode !== "theme_converter") return;

  var STORAGE_KEY = "bls_display_currency";
  var MANUAL_KEY = "bls_currency_manual";
  var GEO_COUNTRY_KEY = "bls_geo_detected_country";
  var symbols = config.symbols || {};
  var rates = config.rates || {};
  var countryMap = config.countryMap || {};

  function getCurrency() {
    try {
      return localStorage.getItem(STORAGE_KEY) || config.defaultCurrency || "INR";
    } catch (error) {
      return config.defaultCurrency || "INR";
    }
  }

  function setCurrency(code, isManual) {
    if (!code) return;
    try {
      localStorage.setItem(STORAGE_KEY, code);
      if (isManual !== false) {
        localStorage.setItem(MANUAL_KEY, "true");
      }
    } catch (error) {
      /* ignore */
    }
    afterCartUpdate();
    updateSwitcherLabels();
  }

  function formatInr(cents, options) {
    var amount = cents / 100;
    var text = "₹ " + amount.toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    if (options && options.showMrp) text = "MRP\u00a0" + text;
    if (options && options.stripZeros) text = text.replace(/\.00$/, "");
    return text;
  }

  function formatForeign(cents, currency, options) {
    var rate = Number(rates[currency]);
    if (!rate) return formatInr(cents, options);
    var amount = cents / 100 / rate;
    var symbol = symbols[currency] || currency + " ";
    var text =
      symbol +
      amount.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    if (options && options.showMrp) text = "MRP\u00a0" + text;
    return text;
  }

  function format(cents, currency, options) {
    currency = currency || getCurrency();
    if (!cents && cents !== 0) return "";
    if (currency === "INR") return formatInr(cents, options);
    return formatForeign(cents, currency, options);
  }

  function convertAll() {
    var currency = getCurrency();
    document.querySelectorAll("[data-price-inr-cents]").forEach(function (node) {
      var cents = parseInt(node.getAttribute("data-price-inr-cents"), 10);
      if (isNaN(cents)) return;
      var options = {
        showMrp: node.getAttribute("data-show-mrp") === "true",
        stripZeros: node.getAttribute("data-strip-zeros") === "true",
      };
      node.textContent = format(cents, currency, options);
    });
    document.documentElement.setAttribute("data-display-currency", currency);
  }

  function updateSwitcherLabels() {
    var currency = getCurrency();
    var symbol = symbols[currency] || currency;
    document.querySelectorAll("[data-currency-switcher-label]").forEach(function (node) {
      node.textContent = currency + " (" + symbol + ")";
    });
    document.querySelectorAll("[data-currency-option]").forEach(function (node) {
      var code = node.getAttribute("data-currency-option");
      if (code === currency) {
        node.setAttribute("aria-current", "true");
        node.classList.add("active");
      } else {
        node.removeAttribute("aria-current");
        node.classList.remove("active");
      }
    });
  }

  function bindSwitcher() {
    document.querySelectorAll(".currency-display-switcher .button-localization").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var list = button.parentElement.querySelector(".disclosure__list");
        if (!list) return;
        list.classList.toggle("hidden");
      });
    });

    document.addEventListener("click", function (event) {
      if (!event.target.closest(".currency-display-switcher")) {
        document.querySelectorAll(".currency-display-switcher .disclosure__list").forEach(function (list) {
          list.classList.add("hidden");
        });
      }
    });

    document.querySelectorAll("[data-currency-option]").forEach(function (node) {
      node.addEventListener("click", function (event) {
        event.preventDefault();
        setCurrency(node.getAttribute("data-currency-option"), true);
        var list = node.closest(".disclosure__list");
        if (list) list.classList.add("hidden");
      });
    });
  }

  function detectByIp() {
    if (!config.autoDetect) return Promise.resolve();

    var root = config.storeRoot || "/";
    return fetch(
      root + "browsing_context_suggestions.json?country[enabled]=true",
      { credentials: "same-origin" }
    )
      .then(function (response) {
        if (!response.ok) throw new Error("geo failed");
        return response.json();
      })
      .then(function (data) {
        var country = String(
          (data.detected_values &&
            data.detected_values.country &&
            data.detected_values.country.handle) ||
            (data.suggestions &&
              data.suggestions[0] &&
              data.suggestions[0].parts &&
              data.suggestions[0].parts.country &&
              data.suggestions[0].parts.country.handle) ||
            ""
        ).toUpperCase();
        if (!country) return;

        var prevCountry = "";
        var isManual = false;
        try {
          prevCountry = localStorage.getItem(GEO_COUNTRY_KEY) || "";
          isManual = localStorage.getItem(MANUAL_KEY) === "true";
        } catch (error) {
          /* ignore */
        }

        try {
          localStorage.setItem(GEO_COUNTRY_KEY, country);
        } catch (error) {
          /* ignore */
        }

        if (typeof window.filterAnnouncementsByGeo === "function") {
          window.filterAnnouncementsByGeo(country);
        }

        if (isManual) return;

        var currency = countryMap[country] || config.defaultCurrency || "INR";
        if (country !== prevCountry || !localStorage.getItem(STORAGE_KEY)) {
          try {
            localStorage.setItem(STORAGE_KEY, currency);
          } catch (error) {
            /* ignore */
          }
        }
      })
      .catch(function () {
        /* keep current currency */
      });
  }

  function afterCartUpdate() {
    convertAll();
    document.querySelectorAll('free-ship-progress-bar[data-inr-threshold="true"]').forEach(function (bar) {
      if (typeof bar.init === "function" && bar.dataset.order) {
        bar.init(bar.dataset.order);
      }
    });
  }

  var gridObserver;
  var convertDebounce;

  function scheduleConvertAll() {
    clearTimeout(convertDebounce);
    convertDebounce = setTimeout(convertAll, 50);
  }

  function nodeHasConvertiblePrice(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches("[data-price-inr-cents]")) return true;
    return !!(node.querySelector && node.querySelector("[data-price-inr-cents]"));
  }

  function observeProductGrids() {
    if (typeof MutationObserver === "undefined") return;
    if (gridObserver) gridObserver.disconnect();
    gridObserver = new MutationObserver(function (mutations) {
      var hasNewPrices = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(nodeHasConvertiblePrice);
      });
      if (hasNewPrices) scheduleConvertAll();
    });
    var gridSelectors = [
      "#bls__product-grid",
      "[id^='bls__product-grid-']",
      "#productgridcontainer",
      ".bls__product-recently-viewed",
      ".bls__product-recommendations-section",
      ".product-recommendations",
      "minicart-recommendations",
      "minicart-recommendations-beside",
      "minicart-recommendations-page",
      ".bls__rv-page-main",
    ];
    document.querySelectorAll(gridSelectors.join(", ")).forEach(function (grid) {
      gridObserver.observe(grid, { childList: true, subtree: true });
    });
  }

  function refreshProductPrices() {
    convertAll();
    observeProductGrids();
  }

  window.CurrencyDisplay = {
    getCurrency: getCurrency,
    setCurrency: setCurrency,
    format: format,
    convertAll: convertAll,
    afterCartUpdate: afterCartUpdate,
    observeGrids: observeProductGrids,
    refreshProductPrices: refreshProductPrices,
  };

  window.theme = window.theme || {};
  window.theme.formatInrMoney = function (amount, options) {
    options = options || {};
    return format(amount, getCurrency(), {
      showMrp: options.showMrp,
      stripZeros: options.stripZeros !== false,
    });
  };

  bindSwitcher();
  try {
    var cachedGeoCountry = localStorage.getItem(GEO_COUNTRY_KEY);
    if (cachedGeoCountry && typeof window.filterAnnouncementsByGeo === "function") {
      window.filterAnnouncementsByGeo(cachedGeoCountry);
    }
  } catch (error) {
    /* ignore */
  }
  detectByIp().finally(function () {
    afterCartUpdate();
    updateSwitcherLabels();
    observeProductGrids();
  });

  document.addEventListener("shopify:section:load", function () {
    afterCartUpdate();
    observeProductGrids();
  });
})();
